import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import { useSearchParams } from "react-router-dom";
import productActions from "../../../../store/actions/items/item.actions";
import { useEffect, useState } from "react";
import TextInputElementComponent from "../../../general/elements/inputElements/TextInputElementComponent";
import textInputModel from "../../../../models/general/elements/inputElements/textInput.model";
import LoaderComponent from "../../../general/LoaderComponent";
import SwitchElementComponent from "../../../general/elements/inputElements/SwitchElementComponent";
import TextAreaInputElementComponent from "../../../general/elements/inputElements/TextAreaInputElementComponent";
import validationHelper from "../../../../helpers/validation.helper";
import AlertService from "../../../../services/alerts/alert.service";

export const UpdateItemExtensionsDialogComponent = ({ productActions }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [item, setItem] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const itemId = searchParams.get("itemId");

  useEffect(() => {
    if (itemId) {
      fetchItemData();
    }
  }, [itemId]);

  const fetchItemData = async () => {
    setLoading(true);
    try {
      const response = await productActions.getProductById(itemId);
      if (response) {
        setItem(response);
      }
    } catch (error) {
      console.error("Error fetching item:", error);
    }
    setLoading(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setItem({ ...item, [name]: value });
  };

  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;
    setItem({ ...item, [name]: checked });
  };

  const validateValues = () => {
    const validationErrors = {};
    if (+item.minOrderQuantity <= 0) {
      validationErrors.minOrderQuantity = "כמות מינימום לא יכולה להיות שלילית.";
    }
    if (+item.displayOrder <= 0) {
      validationErrors.displayOrder = "סדר התצוגה חייב להיות מספר חיובי.";
    }
    if (item.fullDescription && item.fullDescription.length > 500) {
      validationErrors.fullDescription = "תיאור הפריט יכול להכיל עד 500 תווים בלבד.";
    }
    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateValues()) return;
    try {
      const updateData = {
        isAvailable: item.isAvailable,
        displayOrder: item.displayOrder,
        minOrderQuantity: item.minOrderQuantity,
        fullDescription: item.fullDescription,
        isPriceChanged: item.isPriceChanged,
      };
      const response = await productActions.updateItemExtension(item.itemId, updateData);
      if (!validationHelper.validateHttpResponse(response)) {
        setErrors({ general: "אירעה שגיאה בעדכון הפריט. נסה שוב מאוחר יותר." });
        return;
      }
      AlertService.success(`פריט ${item.itemId} - ${item.itemDescription} עודכן בהצלחה`);
    } catch (error) {
      setErrors({ general: "אירעה שגיאה בעדכון הפריט. נסה שוב מאוחר יותר." });
    }
  };

  const getIsAvailableSwitchElement = () => {
    const switchProps = {
      name: "isAvailable",
      label: "זמינות המוצר באתר",
      checked: item?.isAvailable || false,
      onChange: handleSwitchChange,
      customDesignClass: "customSwitchClass",
    };
    return <SwitchElementComponent props={switchProps} />;
  };

  const getIsPriceChangedSwitchElement = () => {
    const switchProps = {
      name: "isPriceChanged",
      label: "מחיר הפריט השנתנה",
      checked: item?.isPriceChanged || false,
      onChange: handleSwitchChange,
      customDesignClass: "customSwitchClass",
    };
    return <SwitchElementComponent props={switchProps} />;
  };

  const getDisplayOrderInputElement = () => {
    const inputProps = {
      ...textInputModel,
      name: "displayOrder",
      error: errors.displayOrder,
      value: item.displayOrder,
      onChange: handleInputChange,
      label: "סדר תצוגה",
      type: "number",
    };
    return <TextInputElementComponent props={inputProps} />;
  };

  const getMinOrderQuantityInputElement = () => {
    const inputProps = {
      ...textInputModel,
      name: "minOrderQuantity",
      error: errors.minOrderQuantity,
      value: item.minOrderQuantity,
      onChange: handleInputChange,
      label: "מינמום יחידות להזמנה (להגדרה כמארז)",
      type: "number",
    };
    return <TextInputElementComponent props={inputProps} />;
  };

  const getFullDescriptionInputElement = () => {
    const inputProps = {
      ...textInputModel,
      name: "fullDescription",
      error: errors.fullDescription,
      value: item.fullDescription,
      onChange: handleInputChange,
      label: "תיאור פריט",
    };
    return <TextAreaInputElementComponent props={inputProps} />;
  };

  if (!item || loading) return <LoaderComponent />;

  return (
    <div className="dialogContainer">
      <h1>
        {item.itemId} - {item.itemDescription}
      </h1>
      <form onSubmit={handleSubmit} className="flex fdColumn gap10">
        {getIsAvailableSwitchElement()}
        {getIsPriceChangedSwitchElement()}
        {getDisplayOrderInputElement()}
        {getMinOrderQuantityInputElement()}
        {getFullDescriptionInputElement()}
        <button type="submit" className="primaryButton">
          עדכן
        </button>
        {errors.general && <span className="error">{errors.general}</span>}
      </form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  categories: state.categoryReducer.categories?.items, // Subscribe to categories state from the reducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    productActions: bindActionCreators(productActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateItemExtensionsDialogComponent);
